import { render } from "./AppNewsDetailPage.vue?vue&type=template&id=4d1c455c&scoped=true&ts=true"
import script from "./AppNewsDetailPage.ts?vue&type=script&lang=ts"
export * from "./AppNewsDetailPage.ts?vue&type=script&lang=ts"

import "./AppNewsDetailPage.vue?vue&type=style&index=0&id=4d1c455c&scoped=true&lang=css"

import exportComponent from "/usr/src/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4d1c455c"]])

export default __exports__